module.exports = __webpack_public_path__ + "static/media/bn.0adbb664.svg";